export const API_URL = process.env.VUE_APP_API_URL
export const API_URL_LOCAL = process.env.VUE_APP_API_URL_LOCAL

export const BASE_URL =
  process.env.NODE_ENV === 'development' ? API_URL_LOCAL : API_URL

export const URL_LOCAL = process.env.VUE_APP_API_URL

export const VERSION = process.env.VUE_APP_VERSION

export const BUILD_DATE = process.env.VUE_APP_BUILD_DATE

// Logs para debug
console.log('API_URL:', API_URL)
console.log('API_URL_LOCAL:', BASE_URL)
console.log('BASE_URL:', BASE_URL)
console.log('URL_LOCAL:', BASE_URL)
